import {
  AccessTime as AccessTimeIcon,
  AssessmentOutlined as AssessmentOutlinedIcon,
  Build as BuildIcon,
  BusinessOutlined as BusinessOutlinedIcon,
  NotificationsNoneOutlined as NotificationsNoneOutlinedIcon,
  PaymentOutlined as PaymentOutlinedIcon,
  SentimentVerySatisfiedOutlined as SentimentVerySatisfiedOutlinedIcon,
  StarBorder as StarBorderIcon,
  SwapHoriz as SwapHorizIcon,
  Tune as TuneIcon,
  TwoWheeler as TwoWheelerIcon,
} from "@mui/icons-material";

import Cardapio from "../../../imagens/cardapio.svg";
import Pedidos from "../../../imagens/pedidos.svg";
import QrCode from "../../../imagens/qrCode.svg";
import { Avatar } from "@mui/material";

export const menuPrincipal = [
  {
    to: "/Dashboard",
    label: "Dashboard",
    icon: <AssessmentOutlinedIcon color="black" />,
  },
  {
    to: "/Cardapio",
    label: "Cardápio",
    icon: <Avatar src={Cardapio} />,
  },
  {
    to: "/Pedidos",
    label: "Pedidos",
    icon: <Avatar src={Pedidos} />,
  },
  {
    to: "/Avaliacoes",
    label: "Avaliações",
    icon: <StarBorderIcon style={{ height: "40px" }} />,
  },
  {
    to: "/Clientes",
    label: "Clientes",
    icon: <SentimentVerySatisfiedOutlinedIcon style={{ height: "40px" }} />,
  },
];

export const settingsMenu = [
  {
    to: "/Configuracoes",
    label: "Gerais",
    icon: <TuneIcon color="black" />,
  },
  {
    to: "/Delivery",
    label: "Delivery",
    icon: <TwoWheelerIcon color="black" />,
  },
  {
    to: "/Identificadores",
    label: "Mesas e QRCodes",
    icon: <Avatar src={QrCode} />,
  },
  {
    to: "/FormaPagamento",
    label: "Formas de Pagamento",
    icon: <PaymentOutlinedIcon color="black" />,
  },
  {
    to: "/HorarioAbertura",
    label: "Horário de Abertura",
    icon: <AccessTimeIcon color="black" />,
  },
  {
    to: "/chamados",
    label: "Chamados",
    icon: <NotificationsNoneOutlinedIcon color="black" />,
  },
];

export const adminMenu = [
  {
    to: "/Empresas",
    label: "Empresas",
    icon: <BusinessOutlinedIcon color="black" />,
  },
  {
    to: "/Usuario",
    label: "Mudar Empresa",
    icon: <SwapHorizIcon color="black" />,
  },

  //TODO: Ativar quando o bot estiver no ar
  // {
  //   to: "/prompt",
  //   label: "Alterar Prompt",
  //   icon: <BuildIcon fontSize="small" color="black" />,
  // },
];
